import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import {isEmpty} from "lodash";
import React from "react";
import {initials as initialsOf} from "common/helpers";
import {font, match} from "common/tokens";
import ShimmerImage from "components/redesign/ShimmerImage";

const useStyles = makeStyles({
  avatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    background: match.AVATAR_BG,
    color: match.AVATAR_FG,
    fontFamily: font.SANS,
    fontWeight: font.BOLD,
    // Always bordered, transparent until selected: adding a border on
    // selection shrinks the inner box and shifts the initials.
    border: '2px solid transparent',
    boxSizing: 'border-box',
  },
  selected: {
    borderColor: match.CARD_SELECTED_BORDER,
  },
  clickable: {
    cursor: 'pointer',
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
  },
});

const Avatar = ({displayName = '', displayPicture = '', size = 44, fontSize = 14, isSelected = false, onClick, className}) => {
  const classes = useStyles();

  return (
    <span
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      title={displayName || undefined}
      className={classNames(classes.avatar, isSelected && classes.selected, onClick && classes.clickable, className)}
      style={{width: size, height: size, fontSize}}
    >
      {isEmpty(displayPicture)
        ? initialsOf(displayName)
        : <ShimmerImage src={displayPicture} className={classes.image}/>}
    </span>
  );
};

export default Avatar;
